export type Credentials = {
  username: string
  password: string
}

export function createCredentialsType(username: string, password: string): Credentials {
  return { username, password }
}
